import icon1 from '../images/mentImg/AnjanaSinha.jpg'
import icon2 from  "../images/mentImg/GunoorKaur.jpg"
import icon3 from "../images/mentImg/Kamakshi_Pant.jpg"
import icon4 from  "../images/mentImg/Karuna.jpg"
import icon5 from  "../images/mentImg/Pallavi.jpg"
import icon6 from  "../images/mentImg/ParulHariharan.jpg"
import icon7 from  "../images/mentImg/RamyaSuresh.jpg"
import icon8 from  "../images/mentImg/Rochelle.jpg"
import icon9 from  "../images/mentImg/ShewtaBapat.jpg"
import icon10 from  "../images/mentImg/VarshaPoddar.jpg"
import icon11 from  "../images/mentImg/VineetaSingh.jpg"

const mentConstant1 = [
	{
        imgUrl: icon1,
        desc: `<div>Anjana is a transactional lawyer with a total of 15 years of experience in private equity and M&A. She began her career working with leading law firms in India, namely Kochhar & Company and Singhania & Partners. She has advised several national and international clients on issues relating to joint venture, mergers and acquisitions, entry strategies in India and issues relating to foreign exchange laws. Before joining Investcorp, she has worked extensively on private equity transactions during her association with Bennett, Coleman & Co. Limited, the largest media conglomerate in India, and RoundGlass Partners (a US based private equity /venture capital investor). Anjana holds B.Com and LL.B. degree from Delhi University.”

        </div>`,
        name:"Anjana Sinha",
        oldcompany:"Investcorp India",
        oldpost:"Senior Vice President",
        newpost:"-",
        newcompany:"-",
        linkedIn:"https://www.linkedin.com/in/anjana-sinha-1253168/",
    },
    {
        imgUrl: icon2,
        desc: `<div>Gurnoor Kaur is an investment professional at TA Associates and focuses on investments in business services companies in India. Prior to TA, Gurnoor was at Rothschild & Co. where she was an Associate in the Telecom, Energy and Healthcare group.  She earned a Bachelor of Commerce from Shri Ram College of Commerce, Delhi University and a Master’s in Business Administration from the Indian Institute of Management, Kozhikode.
       </div>`,
        name:" Gurnoor Kaur",
        oldcompany:"TA Associates",
        oldpost:"Growth Equity Investor",
        newpost:"Senior Vice President",
        newcompany:"TA Associates",
        linkedIn:"https://www.linkedin.com/in/gurnoor-kaur-46399432/",
    },
    {
        imgUrl: icon3,
        desc: `<div>Kamakshi is Vice President of Strategy and Marketing at Taggd by PeopleStrong. In her current role, she is responsible for designing and executing the growth and business strategy and special projects for Taggd in collaboration with the Executive Team. In addition to this, she leads the Marketing and Branding initiatives of Taggd and is responsible for enabling the growth of Taggd through differentiated brand positioning, digital marketing, and thought leadership. Creating a Brand’s Identity and bringing it to life through detailed execution is one of her key interest areas. Kamakshi is a music and art enthusiast and in her free time loves experimenting with them.
        </div>`,
        name:"Kamakshi Pant",
        oldcompany:"Taggd",
        oldpost:"Vice President Strategy and Marketing",
        newpost:"Chief Business Officer Partner",
        newcompany:"Taggd Work Capital",
        linkedIn:"https://www.linkedin.com/in/kamakshipant/",
    },
    {
        imgUrl: icon4,
        desc: `<div>Karuna has extensive experience and expertise in early-stage impact and private equity investing in healthcare and renewables. Karuna is building Enzia which is a $40mn sector-focused, an early-stage investment fund investing in health, education and environment sectors.
        Prior to Enzia, she worked in senior positions at Acumen, Aditya Birla Group and Grasim Industries. Karuna has been a member on the boards of several of Acumen’s portfolio companies including LifeSpring Hospitals, Frontier Markets, Edubridge Learning Systems, and Sewa Grih Rin. Other companies she worked with include Healthcubed, Ayurvaid, and Husk Power Systems. 
        Karuna’s experience has helped her gain deep-rooted insights into India II and III markets, consumer behaviors and cross-sectoral investing. She combines these insights with her eye for detail and proficiency in working with founders to help Enzia’s portfolio companies build strategy and value.
        Karuna is a CA and holds an MBA from ISB, Hyderabad.
        
            </div>`,
        name:"Karuna Jain",
        oldcompany:"Enzia Ventures",
        oldpost:"Co - Founder and Partner",
        newpost:"-",
        newcompany:"-",
        linkedIn:"https://www.linkedin.com/in/karuna-jain-10569b7/",
    },
    {
        imgUrl: icon5,
        desc: `<div>Pallavi specialises in Fund, M&A Joint Ventures General Corporate and Private Equity. She has diverse advisory experience in negotiation, corporate and foreign exchange related advice and regulatory compliances while dealing with authorities, including the RBI, SEBI and the Department of Economic Affairs.  Pallavi is a Company Secretary and holds an LL.B degree from Government Law College – University of Mumbai. 

        </div>`,
        name:"Pallavi Satpute",
        oldcompany:" AZB & Partners",
        oldpost:"Counsel ",
        newpost:"Senior Associate",
        newcompany:"Al Tamimi & Company",
        linkedIn:"https://www.linkedin.com/in/pallavi-satpute-5a85a652/",
    },
    {
        imgUrl: icon6,
        desc: `<div>Parul has over 14 years of investing experience across the transaction lifecycle, with her area of focus in financial institutions. She currently works at CDC Group, UK’s development financial institution (DFI) and previously at Aquarius Investment Advisors, a mid-cap growth capital private equity fund. She has experience in making equity investments, portfolio monitoring and exits. Parul has an MBA from the Indian School of Business (ISB), Hyderabad and is also a qualified Chartered Accountant (CA) from the Institute of Chartered Accountants of India (ICAI).

       </div>`,
        name:"Parul Hariharan",
        oldcompany:"CDC Group PLC",
        oldpost:"Manager - Financial Institutions, Equity",
        newpost:"Financial Institutions, Direct Equity, South Asia",
        newcompany:"British International Investment Plc",
        linkedIn:"https://www.linkedin.com/in/parul-hariharan-4433402/",
    },
    {
        imgUrl: icon7,
        desc: `<div>Ramya is a General Corporate and M&A lawyer with 10 years’ experience, currently working as a Counsel in Trilegal. Due to her sector agnostic practice, she led the team in several high-value deals ranging from strategic investments, PE/VC investments, securities sales and purchases, asset and business purchases, co-investments and joint ventures in tech-solution start-ups, renewable energy projects, e-pharmacy, non-banking finance, e-learning, as well as JV/other investment exits.<br/><Br/>
        Ramya prior to Trilegal worked with DSK Legal, Delhi for 3 years. She is also an alumnus of Amity Law School, New Delhi (Batch of 2011) registered with the Bar Council of Delhi and a Company Secretary. 
        
       </div>`,
        name:"Ramya Suresh",
        oldcompany:"Trilegal",
        oldpost:"Counsel",
        newpost:"Partner Director",
        newcompany:"Saraf & Partners Mylan",
        linkedIn:"https://www.linkedin.com/in/ramya-suresh/",
    },
    {
        imgUrl: icon8,
        desc: `<div>Ms. D’Souza is a managing director at Lighthouse Advisors, a leading mid-market, private equity investment firm. She co-leads the investment team and specializes in food, healthcare and agri sectors.<br/>

        In addition to Tynor Orthotics, Ms. D’Souza’s current board positions include Wow! Momo Foods, which is India’s largest homegrown QSR brand, and V2 Retail, a leading value retailer.<br/>
        
        In her personal time, she serves as a mentor for the YEA Academy and is also an ambassador for Winpe, the network for women in private equity. She was Ranked among the Top 100 Women in Finance by AIWMI in 2019;
        <Br/>
        Ms. D’Souza received her MBA from the SP Jain School of Management and holds a Bachelor in Engineering in Electronics from RVCE
        
       </div>`,
        name:"Rochelle D'Souza",
        oldcompany:"Lighthouse Advisors",
        oldpost:"Managing Director",
        newpost:"-",
        newcompany:"-",
        linkedIn:"https://www.linkedin.com/in/rochelle-dsouza-448169b/",
    },
    {
      imgUrl: icon9,
      desc: `<div>Shweta Bapat is a Senior Associate at EverSource Capital, Everstone Group. She has over 9 years’ experience in private equity, M&A and equity research. At EverSource Capital, her focused sectors are e-mobility, waste management & renewables. She has extensive experience of working with companies and helping them formulate a growth plan, recommending changes in their existing business plans, structuring and key processes. Prior to EverSource Capital, she has worked with Deutsche Bank. Shweta holds a Bachelor of Management Studies from the University of Mumbai and an MSc Finance degree from Lancaster University, United Kingdom.

         </div>`,
          name:"Shweta Bapat",
          oldcompany:"EverSource Capital, Everstone Group",
        oldpost:"Senior Associate",
        newpost:"Vice President",
        newcompany:"Ruya Partners",
        linkedIn:"https://ae.linkedin.com/in/shweta-shastri-5262b441/",
    },
    {
      imgUrl: icon10,
      desc: `<div>Varsha has been with CDPQ for 5+ years. Varsha covers the Indian market working on the CDPQ India strategy and multiple India deals across listed and private equity. Varsha has in total 9+ years of experience (6+ years in investments & banking and 3+ years working with global accounting firms). Before joining CDPQ Varsha worked with Avendus Capital as an Associate in the Consumer's & financial services team (Investment Banking Division). Prior to her MBA she worked at Deutsche Bank in India as an Analyst in the Corporate Banking team. Varsha holds an MBA from The Indian Institute of Management, Bangalore. Varsha is a Chartered Accountant and secured an AIR of 33 in CA Final along with earning her Bachelors’ degree in Commerce from Narsee Monjee College. Apart from work, Varsha is very passionate about sports. She was a member of the Indian Throwball team representing India at the international level. Varsha follows tennis very religiously and is a big Rafael Nadal fan.  

         </div>`,
          name:"Varsha M. Poddar",
          oldcompany:"CDPQ India",
      oldpost:"Senior Associate, Infrastructure",
      newpost:"Vice President",
        newcompany:"ESSAR CAPITAL LIMITED",
        linkedIn:"https://www.linkedin.com/in/varsha-poddar-5548b858/",
    },
    {
        imgUrl: icon11,
        desc: `<div>Vineeta served many leadership positions at various other multi-million-dollar businesses since and successfully building India’s largest beauty subscription service along the way – Vineeta co-founded SUGAR Cosmetics in 2015 with a single-point agenda of creating world-class makeup products with high-pigmentation that specifically catered to the Indian skin tone. Vineeta in 2021 was able to raise $21 Million (INR 153 Cr) Series C funding round led by Elevation Capital (formerly, SAIF Partners), with existing investors A91 Partners, India Quotient participating and strategic venture debt from Stride Ventures.<Br/><br/>
        Vineeta has an individual TEDx talk to her credit where she has shared candid details about her journey. She is also a fitness buff with numerous ultra-marathons & triathlons to her credit. Being an avid runner for the last decade, she has completed the Comrades Ultra-marathon which is 89 km long, thrice from 2012-14. Apart from that, Vineeta and her husband are also the first Indian couple to finish the grueling long-distance Ironman triathlon in Austria (3.8km swim, 180km cycle, 42.2km run) – which is widely regarded as the toughest single-day sporting event in the world. 
        
        </div>`,
        name:"Vineeta Singh",
        oldcompany:"SUGAR Cosmetics",
        oldpost:"CEO & Co-Founder ",
        newpost:"CEO & Co-Founder",
        newcompany:"SUGAR Cosmetics",
        linkedIn:"https://www.linkedin.com/in/vineetasingh/",
    },
   
	
]

export default mentConstant1


// WEBPACK FOOTER //
// ./src/constant/mentConstant1.js